import React from 'react';
import { Layout as AntLayout } from 'antd';
import cn from 'classnames';

import Brand from '@components/layout/Brand';

const { Header, Content } = AntLayout;

function AuthLayout({ className, icon, title, children }) {
  return (
    <AntLayout className="layout auth-layout">
      <Header className="auth-layout__header">
        <Brand theme="dark" withoutHamburger />
      </Header>
      <div className="auth-layout__main">
        {icon && <div className="auth-layout__icon">{icon}</div>}
        {title && <div className="auth-layout__title">{title}</div>}
        <Content className={cn('auth-layout__content', className)}>
          {children}
        </Content>
      </div>
    </AntLayout>
  );
}

export default AuthLayout;
